<a
  class="flex items-center gap-1 text-steel-100 font-normal p-2 lg:!no-underline lg:gap-2 ease-out duration-500 hover:text-blue-50 rounded-3xl shadow-none transition-shadow hover:shadow-md"
  routerLink="/search"
  *transloco="let t; read: scope()">
  <rma-icon glyph="search" theme="primary" />
  <span class="sr-only lg:not-sr-only">{{ t('search') }}</span>
  <rma-icon class="!hidden lg:!inline-flex" glyph="chevron_right" theme="primary" />
</a>
